export default function objectSize(obj) {
  return Object.keys(obj).length;
}
